<template>
  <div class="u-grid__item [ u-2/3@wide ]">
    <div class="c-live-panel">
      <a :href="programUrl" class="c-live-panel__main" :style="styleObject"></a>
      <div class="c-live-panel__footer">
        <div class="c-live-panel__footer-wrapper">
          <span class="c-live-panel__footer-time">{{start}}</span>
          <a :href="programUrl" class="c-live-panel__footer-title">{{program.title}}</a>
        </div>
        <div class="c-live-panel__footer-actions">
          <a v-if="channel && channel.hasVideo" @click.prevent="openVideo(mainChannelId)" href="#" class="c-button c-button--base">Kijk</a>
          <a @click.prevent="openChannel(mainChannelId)" href="#" class="c-button c-button--base">Luister</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { openPlayer } from '../../mixins/radioPlayer';
import { cdnUrl } from '../../filters/imageFilters'
import { format, parseISO } from 'date-fns';

const HOUR_FORMAT = 'HH:mm';

export default {
  name: 'ProgramLive',
  mixins: [openPlayer],
  computed: {
    ...mapState({
      channels: state => state.channels.channels,
      mainChannelId: state => state.stations.stationId,
      program: state => state.program.program,
      start: state => state.program.program ? format(parseISO(state.program.program.start), HOUR_FORMAT) : '',
    }),
    styleObject() {
      return (this.program && this.program.programCurrentImage) ? {
        backgroundImage : `url(${cdnUrl(this.program.programCurrentImage) })`,
      } : {};
    },
    channel() {
      return this.channels.find((channel) => channel.id === this.mainChannelId);
    },
    programUrl() {
      return `/programmas/${this.program.slug || this.program.programId}`
    },
  },
};
</script>
